module.exports = __webpack_public_path__ + "img/shouce.66bb6891.jpg";